import {useNavigate} from "react-router";
import React from "react";
import {
    Container,
    DocButton,
    DocCard,
    DocCardContainer,
    DocCardContent,
    DocCardText,
    DocCardTitle,
    HeaderLayout,
    HomeHeader,
    imageHeader,
    SubTitleHeader,
    TitleHeader
} from "./HeaderItem.css";
import {Button, Card} from "@elcimai/webankdesignsystem";


export interface HeaderItemProps {
    title: string,
    description: string,
    imageUrl: string,
    onClick: () => void,
}

const HeaderItem = ({title, imageUrl, description, onClick}:HeaderItemProps) => {
    useNavigate();
    return (
        <div className={HeaderLayout}>
            <div className={HomeHeader}>
                <div className={Container}>
                    <p className={TitleHeader}>{title}</p>
                    <p className={SubTitleHeader}>{description}</p>
                </div>
                <img className={imageHeader} src={imageUrl} alt={"api illustration"}/>
            </div>
            <div className={DocCardContainer}>
                <Card className={DocCard} isBehind={true}>
                    <div className={DocCardContent}>
                        <p className={DocCardTitle}>Développeurs</p>
                        <p className={DocCardText}>Accédez à notre documentation complète. Explorez les fonctionnalités et facilitez votre Intégration</p>
                        <Button className={DocButton} onClick={onClick} label={"Accédez à la documentation"}></Button>
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default HeaderItem;